import { MenuItem } from 'shared';

import { useAddChallengesToSprint } from 'features/timeline/hooks/mutation/useAddChallengesToSprint';

import { showLoadingToast, updateToast } from 'shared/components/Toast/Toast';

type TGoalChallengeCardMenuAddToSprintButton = {
  challengeId: string;
};

export const GoalChallengeCardMenuAddToSprintButton = ({
  challengeId,
}: TGoalChallengeCardMenuAddToSprintButton) => {
  const { mutateAsync: startChallengeOnSprint } = useAddChallengesToSprint({
    options: {
      retry: false,
    },
  });

  const handleAdd = async () => {
    const toastId = showLoadingToast('Adding challenge...');

    try {
      await startChallengeOnSprint({
        challengeIds: [challengeId],
      });

      updateToast(toastId, {
        render: 'Challenge added!',
        type: 'success',
        isLoading: false,
        icon: false,
      });
    } catch (e) {
      const errorMessage =
        //@ts-ignore
        e.description === `Challenge ${challengeId} is already on timeline`
          ? 'This challenge is already on your sprint.'
          : "There's an error with adding challenge. Please try again later.";

      updateToast(toastId, {
        render: errorMessage,
        type: 'error',
        isLoading: false,
        icon: false,
      });
    }
  };

  return <MenuItem onClick={handleAdd}>Add to sprint</MenuItem>;
};
